import React from 'react';
import { graphql } from 'gatsby';
import SEO, { createSEO } from 'components/SEO';
import WebsiteLayout from 'layouts/websiteLayout';
import IndustriesHeroSection from 'components/IndustriesPage/IndustriesHeroSection';
import IndustriesCardSection from 'components/IndustriesPage/IndustriesCardSection';
import DemoFormSection from 'components/DemoFormSection';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';

const IndustriesPage = props => {
  const { components } = props.data.contentfulWebsitePage;
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  const demoFormSection = {
    backgroundColor: '#00A9F7',
    formTitle: 'Let’s get started.',
    description: {
      description: 'Explore why 100,000+ contractors trust ServiceTitan to run their business.',
    },
    title: 'Book a personalized demo today.',
    formRedirectUrl: 'thankyou',
  };

  const seo = createSEO(
    {
      ...props.data.contentfulWebsitePage,
      pageCategory: 'Industry',
    },
    props
  );

  const featuredIndustryCards = components.filter(ele => ele.title === 'Featured Industries')[0];
  const otherIndustryCards = components.filter(ele => ele.title === 'Other Industries')[0];

  return (
    <WebsiteLayout header={header} footer={footer} hero={{ background: '#00A9F7' }}>
      <SEO {...seo} />
      <IndustriesHeroSection
        background="#00A9F7"
        title="Built for all types of service businesses"
        description="The world’s leading all-in-one software for commercial and residential HVAC, plumbing, electrical, and other field service businesses."
        iconCards={featuredIndustryCards.cards}
      />
      <IndustriesCardSection
        background="#00A9F7"
        title="Other Industries"
        iconCards={otherIndustryCards.cards}
      />
      <DemoFormSection
        backgroundColor={demoFormSection.backgroundColor}
        formTitle={demoFormSection.formTitle}
        description={demoFormSection.description.description}
        title={demoFormSection.title}
        redirectUrl={demoFormSection.formRedirectUrl}
      />
    </WebsiteLayout>
  );
};

export default IndustriesPage;

export const IndustriesPageQuery = graphql`
  query IndustriesPageQuery {
    contentfulWebsitePage(internalName: { eq: "[Industry] ALL Industries" }) {
      metaDescription {
        metaDescription
      }
      slug
      titleTag
      indexable
      canonicalUrl
      pageCategory
      socialSharingImage {
        ...WebsiteImage
      }
      components {
        ...CardsBlock
      }
    }
  }
`;
